export enum SupportedPaymentMethodEnum {
  CARD_PAYMENT = 'cardPayment',
  APPLE_PAYMENT = 'applePayment',
  SKRILL_PAYMENT = 'skrillPayment',
  INTERAC_PAYMENT = 'interacPayment',
  PAYSAFECARD_PAYMENT = 'paysafeCardPayment',
  ACH_REDEEM = 'achRedeem',
  SKRILL_REDEEM = 'skrillRedeem',
  IBT_REDEEM = 'ibtRedeem',
  INTERAC_REDEEM = 'interacRedeem',
  CARD_REDEEM = 'cardRedeem',
  SEPA_REDEEM = 'sepaRedeem',
  PAYOUTS_REDEEM = 'payoutsRedeem',
  PAYSAFECARD_REDEEM = 'paysafeCardRedeem',
}
